export const WILDMETA_DISCORD_URL = 'https://discord.com/invite/fQ6QMuNpnj'

export const WILDMETA_TWITTER_URL = 'https://x.com/wildmetahq'

export const WILDMETA_TELEGRAM_URL = 'https://t.me/wildmeta_traders'

export const DOCUMENTATION_URL = 'https://docs.wildmeta.ai'

export const MEDIA_KIT_URL = 'https://drive.google.com/file/d/1HL89pr_aezU7yOaH3neXvIUkP91SnKqq/view?usp=sharing'

export const APP_PAGE_URL = 'https://large-accessibility-960886.framer.app'